/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Popover } from '@radix-ui/themes';

import { css, styled, useState } from 'fierry/react';


const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;


const Option = styled.button`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid transparent;
  background: transparent;
  border-radius: var(--radius-2);
  cursor: pointer;
  font: inherit;
  font-size: var(--font-size-2);
  color: var(--gray-12);

  &:hover { background: var(--gray-3); }

  ${props => props.$selected && css`
    border-color: var(--accent-11);
    background: var(--accent-a3);
  `}
`;


export default ({ trigger, options, value, onChange, align = 'center' }) =>
{
  const [ open, setOpen ] = useState(false);

  const onPick = (value) => () =>
  {
    onChange(value);

    setOpen(false);
  };

  return (
    <Popover.Root open = {open} onOpenChange = {setOpen}>
      <Popover.Trigger>
        {trigger}
      </Popover.Trigger>
      <Popover.Content size = '1' align = {align} style = {{ padding: 8 }}>
        <List>
          {options.map(option =>
          (
            <Option key = {option.value} type = 'button' $selected = {option.value === value} onClick = {onPick(option.value)}>
              {option.label}
            </Option>
          ))}
        </List>
      </Popover.Content>
    </Popover.Root>
  );
};
